module.exports = __webpack_public_path__ + "img/img-07.a652b21b.jpg";